import { http } from './config'

export default {
  
  getAllProductPackages: (productGroupId) => {
    return http.get('product_packages/?product_id=' + productGroupId)
  },
  createProductPackage: (productPackageParams) => {
    return http.post('product_packages/', {
      locality_id: productPackageParams.locality.id,
      package_id: productPackageParams.package.id,
      product_id: productPackageParams.product_id
    })
  },

  getProductPackageById: (produtPackageID) => {
    return http.get('product_packages/' + produtPackageID)
  },

  updateProductPackage: (productPackageParams) => {
    return http.put('product_packages/' + productPackageParams.produtPackageId, {
      locality_id: productPackageParams.locality.id,
      package_id: productPackageParams.package.id
    })
  },
  
  deleteProductPackage: (produtPackageID) => {
    return http.delete('product_packages/' + produtPackageID)
  }

}